module.exports = __webpack_public_path__ + "img/3.86ce61ae.jpg";